import { format } from 'date-fns-tz';
import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import Badge from '~/components/Badge/Badge';
import { useDateLang } from '~/hooks/useDateLang';
import { useTimeFormat } from '~/hooks/useTimeFormat';
import { userStore } from '~/stores/UserStore';

import { TRANSACTION_STATUS } from './contstants';
import EmptyList from './Empty';
import styles from './History.module.scss';

const History = () => {
  const { t } = useTranslation();
  const { locale } = useDateLang();
  const { timeFormat } = useTimeFormat();

  const loyaltyPointsTransactionsList =
    userStore.loyaltyPointsStore.loyaltyPointsTransactionsList;

  if (!loyaltyPointsTransactionsList.length) {
    return <EmptyList />;
  }

  return (
    <div className={styles.fullProgress}>
      <p className={styles.title}>{t('loyalty:progress:full:title')}</p>
      <ul className={styles.transactionList}>
        {loyaltyPointsTransactionsList.map((transaction) => (
          <li key={transaction.id} className={styles.transactionListItem}>
            <div className={styles.content}>
              <div className={styles.mainInfo}>
                <p className={styles.title}>
                  {t(
                    `loyalty:progress:full:type:${transaction.transactionType}`,
                  )}
                </p>
                {transaction.transactionStatus && (
                  <Badge
                    theme={
                      TRANSACTION_STATUS[transaction.transactionStatus] as
                        | 'pending'
                        | 'primary'
                        | 'canceled'
                        | 'gray'
                        | 'secondary'
                        | 'express'
                    }
                    size="s"
                  >
                    {t(
                      `loyalty:progress:full:status:${transaction.transactionStatus}`,
                    )}
                  </Badge>
                )}
              </div>
              <p className={styles.date}>
                {format(
                  new Date(transaction.createdAt),
                  `dd.MM.yyyy ${timeFormat}`,
                  {
                    timeZone: company.config.timeZone,
                    locale,
                  },
                )}
              </p>
            </div>
            <p
              className={classes([
                styles.value,
                transaction.amount > 0 ? styles.inc : styles.dec,
              ])}
            >
              {transaction.amount > 0
                ? `+${transaction.amount}`
                : transaction.amount}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default observer(History);
